// Подзаголовок шапки чата (SPEC §4.3): из presence/typing/memberCount собираем готовую строку.
// direct: «печатает…» при typing, иначе «в сети»/«был(а) в сети …» (D-09, видно всем). group:
// «печатает…» при typing, иначе «N участников». Чистая — типы из shared-contracts/client-store.

import type { Chat, PublicUser, UserId } from '@tele-chat/shared-contracts'
import type { TypingSignal, PresenceSlice } from '@tele-chat/client-store'
import { formatLastSeen } from '@tele-chat/design-system'
import { strings } from '../i18n/strings.js'

export interface SubtitleInput {
  chat: Chat
  typing: TypingSignal[]
  /** presence собеседника в direct. */
  peerPresence?: PresenceSlice
  peerId?: UserId
  resolveUser(id: UserId): PublicUser | undefined
  now?: Date
}

/** Готовая строка подзаголовка шапки. */
export function chatSubtitle(input: SubtitleInput): string {
  const { chat, typing, peerPresence, resolveUser, now } = input

  if (typing.length > 0) {
    const first = typing[0]
    const name = first !== undefined ? (resolveUser(first.userId)?.name ?? '…') : '…'
    const verb = first?.kind === 'recording_voice' ? 'записывает голосовое' : 'печатает'
    if (typing.length === 1) return `${name} ${verb}…`
    return `${typing.length} ${strings.chat.membersCount(typing.length)} печатают…`
  }

  if (chat.type === 'group') {
    return strings.chat.membersCount(chat.memberCount)
  }

  // direct: presence собеседника.
  if (peerPresence === undefined) return ''
  if (peerPresence.state === 'online') return strings.chat.online
  if (peerPresence.lastSeenAt !== undefined) {
    return formatLastSeen(peerPresence.lastSeenAt, now ?? new Date())
  }
  return ''
}
